import React, { useState, useEffect } from "react";
import { PostApi, GetApi, PutApi, PostFormApi } from "../../services/auth.js";
import { Loading } from "../../helpers";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import { Cont } from "./styles";
import { Card, CardBody, Grid, Section, InputContainer, FormLabel, Alert, Container, CardFooter, CardHeader} from "uikit-react";
import UIkit from 'uikit';
import { DateFormatTNew, visible, validaCPF, MascaraCPNJCPF } from "../../services/funcoes";
import ReactPaginate from 'react-paginate';
import Select from 'react-select'
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import ImgPerfilSemFoto from '../../assets/imagens/ImgPerfilSemFoto.jpg';
import ArquivoModelo from '../../assets/ModeloProfissionais.xlsx';

let _Arquivo1 = [];
const Profissionais = () => {
  const ListaStatus = [
    { value: 2476, label: 'ATIVO' },
    { value: 23013, label: 'PRÉ-CADASTRO' },
    { value: 6387, label: 'BLOQUEADO' }
  ];
  const _ListaHabilitacao = [
    { value: 36, label: 'NÃO DISPONÍVEL PARA CONTRATAÇÃO' },
    { value: 37, label: 'DISPONÍVEL PARA CONTRATAÇÃO' },
    { value: 86480, label: 'EM FASE DE CONTRATAÇÃO' },
    { value: 86481, label: 'CONTRATADO' }
  ];
  const [ListaProfissionais, setListaProfissionais] = useState(false);
  const [NomeFiltro, setNomeFiltro] = useState("");
  const [StatusFiltro, setStatusFiltro] = useState("");
  const [HabilitacaoFiltro, setHabilitacaoFiltro] = useState("");
  const [StatusAcesso, setStatusAcesso] = useState("");
  const [StatusHabilitacao, setStatusHabilitacao] = useState(null);
  const [DataCadInicio, setDataCadInicio] = useState("");
  const [DataCadTermino, setDataCadTermino] = useState("");
  const [CPFFiltro, setCPFFiltro] = useState("");
  const [ModalAlteraStatus, setModalAlteraStatus] = useState(false);
  const [ModalAlteraStatusHabilitacao, setModalAlteraStatusHabilitacao] = useState(false);
  const [DadosProfissional, setDadosProfissional] = useState("");
  const [ModalCadastroProfissional, setModalCadastroProfissional] = useState(false);
  const [DadosCadastro, setDadosCadastro] = useState({});
  const [TipoCadastro, setTipoCadastro] = useState('unico');
  const [ListaEspecializacao, setListaEspecializacao] = useState([]);
  const [ListaHabilitacao, setListaHabilitacao] = useState([]);
  const [LoadingExportar, setLoadingExportar] = useState(false);
  const [Arquivo1, setArquivo1] = useState("");
  const [NomeArquivo1, setNomeArquivo1] = useState("Selecione");
  const [FotoArquivo1, setFotoArquivo1] = useState([]);
  const [FileArquivo1, setFileArquivo1] = useState([]);

  //mensagem 
  const [mensagem, Setmensagem] = useState("Nenhuma informação encontrada. Por favor, verifique o filtro aplicado e tente novamente.");

  //Alert
  const [msg, SetMsg] = useState("");
  const [time, SetTime] = useState("");
  const [color, SetColor] = useState(""); //sucess, danger, warning
  const [AlertMsg, SetAlertMsg] = useState(false); 

  //Paginação
  const [itensPerPage, SetItensPerPage] = useState(25);
  const [currentPage, SetCurrentPage] = useState(1);
  const [pageCount, SetPageCount] = useState(0);
  const [pageTotal, SePageTotal] = useState(0);

  const MudaPaginaItens = async (e) => {  
    if(!isNaN(e.nextSelectedPage+1)){      
      SetCurrentPage(e.nextSelectedPage+1)
    }
  }; 

  useEffect(() => {
    GetListaProfissionaiss();
  },[currentPage, itensPerPage]);  
  
  useEffect(() => {  
    window.scrollTo(0, 0); 
  },[currentPage, itensPerPage]);
  
  useEffect(() => {  
    GetListaTipos();
    GetListaHabilitacoes();
  },[]);
  
  const GetListaTipos = async () => {
    const response = await GetApi('Cliente/ListaEspecificacoes?tipo=2479');
    if (response.status === 200) {
      var _ListaEspecializacao = [];
      for (var i = 0; i < response.data.dados.length; i++) {
        _ListaEspecializacao.push({
          value: response.data.dados[i].ProdissaoId,
          label: response.data.dados[i].ProfissaoDescricao
        });
      }
      setListaEspecializacao(_ListaEspecializacao);    
    }    
  };
  
  const GetListaHabilitacoes = async () => {
    const response = await GetApi('Filtros?Cad_tipo=35&Cad_ativo=1');
    if (response.status === 200) {
      var _ListaHabilitacao = [];
      for (var i = 0; i < response.data.filtros.length; i++) {
        _ListaHabilitacao.push({
          value: response.data.filtros[i].cad_cod,
          label: response.data.filtros[i].cad_descricao
        });
      }
      setListaHabilitacao(_ListaHabilitacao);    
    }    
  };
  
  const GetListaProfissionaiss = async () => {  
    setListaProfissionais(false);

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro && StatusFiltro !== null && StatusFiltro !== undefined && StatusFiltro.value !== null && StatusFiltro.value !== undefined){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(HabilitacaoFiltro && HabilitacaoFiltro !== null && HabilitacaoFiltro !== undefined && HabilitacaoFiltro.value !== null && HabilitacaoFiltro.value !== undefined){
      FiltrosURL = FiltrosURL + "StatusVagaId=" + HabilitacaoFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CPFFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CPFFiltro.replace(/\D/g, "") + "&";
    }

    const response = await GetApi('Admin/profissional/?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {
      response.data.profissionais.forEach(element => {
        if(element.statusDescricao){ element.statusDescricao = element.statusDescricao.toLowerCase(); }
        if(element.statusVagaDescricao){ element.statusVagaDescricao = element.statusVagaDescricao.toLowerCase(); }
      })
      setListaProfissionais(response.data.profissionais);
			SetPageCount(Math.ceil(response.data.totalRegistros / itensPerPage));
			SePageTotal(response.data.totalRegistros)
    } else {
      setListaProfissionais([])
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }     
    
  };

  const AbreModalStatusProfissional = async (dados) => {    
    setStatusAcesso(dados.statusId);
    setDadosProfissional(dados);
    setModalAlteraStatus(true);
  };

  const FechaModalStatusProfissional = () => {    
    setModalAlteraStatus(false);
    setTimeout(() => {
      setDadosProfissional("");
    }, 1000);
  };

  const AbreModalStatusHabilitacao = async (dados) => {    
    setStatusHabilitacao(dados.statusVagaId);
    setDadosProfissional(dados);
    setModalAlteraStatusHabilitacao(true);
  };

  const FechaModalStatusHabilitacao = () => {    
    setModalAlteraStatusHabilitacao(false);
    setTimeout(() => {
      setDadosProfissional("");
    }, 1000);
  };

  const AlterarStatusProfissional = async (dados, tipo) => {

    var dados = {
      "entCod": dados.entCod,
    }
    if(tipo === "Acesso"){
      dados.statusAcesso = true;
    }
    if(tipo === "Habilitacao"){
      dados.statusVagaId = StatusHabilitacao && Number(StatusHabilitacao);
    }

    console.log('dados: ', dados);

    // return 

    const response = await PutApi('Admin/profissional/status', dados);
    if (response.status === 200) {
      GetListaProfissionaiss();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
      setModalAlteraStatusHabilitacao(false);
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalAlteraStatus(false);
      setModalAlteraStatusHabilitacao(false);
    }
  };

  const AbreModalCadastroProfissional = () => {
    setDadosCadastro({});
    setTipoCadastro('unico');
    setModalCadastroProfissional(true);
  };

  const FechaModalCadastroProfissional = () => {
    setModalCadastroProfissional(false);
    setTimeout(() => {
      setTipoCadastro('unico');
      setDadosCadastro({});
    }, 1000);
  };

  const CadastrarProfissional = async () => {

		const VerificaEmail = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if(!DadosCadastro?.cpf){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um CPF.",
			});
			return;
    }
    if(!validaCPF(DadosCadastro?.cpf)){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um CPF válido.",
			});
      return;
    }
    if(!DadosCadastro?.nome){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe o nome do profissional.",
			});
      return;
    }
    if(!DadosCadastro?.email){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um e-mail.",
			});
      return;
    }
    if(!VerificaEmail.test(DadosCadastro?.email)) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Você precisa informar um e-mail válido. Exemplo: nome@dominio.com.",
			});
			return;
		}
    var ValidaTelefone = DadosCadastro?.telefone?.replace(/\D/g, "");
    console.log("ValidaTelefone: ", ValidaTelefone);
    if(!ValidaTelefone || ValidaTelefone.length < 10){
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Por favor, informe um telefone válido.",
			});
      return;
    }
    if(!DadosCadastro?.especializacao){
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Por favor, informe uma especialização.",
      });
      return;
    }

		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');

    var DDDTelefone = ValidaTelefone.substring(0, 2);
    var Telefone = ValidaTelefone.substring(2);

    var dados = {
        "nome": DadosCadastro?.nome,
        "cpf": DadosCadastro?.cpf.replace(/\D/g, ""),
        "profissaoId": Number(DadosCadastro?.especializacao),
        "origemId": 6232,
        "email": DadosCadastro?.email,
        "dddTelefone": Number(DDDTelefone),
        "telefone": Number(Telefone)
    }

    console.log('dados: ', dados);

    // return

    const response = await PostApi('Admin/profissional', dados);
    if (response.status === 200) {
      GetListaProfissionaiss();
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("success");
      SetAlertMsg(true);
      setModalCadastroProfissional(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    } else {
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
      setModalCadastroProfissional(false);
      visible('btn-envia-formulario-loading');
      visible('btn-envia-formulario');
      setDadosCadastro({});
    }
  };

  const ExportarDados = async () => {

    var FiltrosURL = "";
    if(NomeFiltro){
      FiltrosURL = FiltrosURL + "Nome=" + NomeFiltro.trim() + "&";
    }
    if(StatusFiltro && StatusFiltro !== null && StatusFiltro !== undefined && StatusFiltro.value !== null && StatusFiltro.value !== undefined){
      FiltrosURL = FiltrosURL + "StatusId=" + StatusFiltro.value + "&";
    }
    if(DataCadInicio){
      FiltrosURL = FiltrosURL + "DataCadInicial=" + DataCadInicio + "&";
    }
    if(DataCadTermino){
      FiltrosURL = FiltrosURL + "DataCadFinal=" + DataCadTermino + "&";
    }
    if(CPFFiltro){
      FiltrosURL = FiltrosURL + "Documento=" + CPFFiltro.replace(/\D/g, "") + "&";
    }

    setLoadingExportar(true);
    const response = await GetApi('Admin/profissional/excel?' + FiltrosURL + 'Pagina=' + currentPage + '&TamanhoPagina=' + itensPerPage );
    if (response.status === 200) {

    try {

      const base64 = response.data.arquivoExcel;
      const binaryString = window.atob(base64);
      const byteNumbers = new Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) { byteNumbers[i] = binaryString.charCodeAt(i); }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Profissionais.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } catch (err) {
      console.error("Erro ao processar o Excel:", err);
      SetMsg("Erro ao processar o arquivo Excel.");
      SetColor("danger");
      SetAlertMsg(true);
      setLoadingExportar(false);
    }

      SetTime(4000);
      SetMsg("Exportação concluída com sucesso!");
      SetColor("success");
      SetAlertMsg(true);
      setLoadingExportar(false);
    } else {
      setLoadingExportar(false);
      SetTime(4000);
      SetMsg(response.data.mensagem);
      SetColor("danger");
      SetAlertMsg(true);
    }
  };

  const UploadProfissionais = async () => {
    if (FileArquivo1.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        html: "Você precisa selecionar um arquivo.",
      });
      return;
    }

		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');

    var dados = new FormData();
    if (_Arquivo1["Arquivo1"]) {
      await dados.append( `ArquivoExcel`, _Arquivo1["Arquivo1"], _Arquivo1["Arquivo1"].name );
    }
    const response = await PostFormApi("Admin/profissional/processa-excel", dados, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache",
      },
    });

    if(response.data.sucesso){
        if (response.data?.erros.length > 0) {

          var mostrarErros = response.data.erros.slice(0, 5);

          // Gera a tabela em HTML
          var htmlTabela = `
            <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; text-align: left; border-collapse: collapse;">
              <thead>
                <tr>
                  <th width="120">CPF</th>
                  <th>Mensagem</th>
                </tr>
              </thead>
              <tbody>
                ${mostrarErros.map(erro => `
                  <tr>
                    <td>${erro.cpf}</td>
                    <td>${erro.mensagem.replace(/\n/g, "<br>")}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `;

          if (response.data.erros.length > 5) {
            htmlTabela += `<p style="margin-top:10px;">Entre outros erros...</p>`;
          }

          Swal.fire({
            title: 'Atenção',
            html: htmlTabela,
            icon: 'warning'
          });


        } else {
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: "Profissionais cadastrados com sucesso!",
        });
        GetListaProfissionaiss();
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro!",
        html: response.data.mensagem,
      });
    }

    setArquivo1("");
    setNomeArquivo1("Selecione");
    setFotoArquivo1([]);
    setFileArquivo1([]);
		visible('btn-envia-formulario-loading');
    visible('btn-envia-formulario');
    setTipoCadastro('unico');
    setDadosCadastro({});
    setModalCadastroProfissional(false);
    GetListaProfissionaiss();

  }

  const LeArquivo = async (e, tipo) => {
    var ListaTiposAnexos = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ]
    var arquivo = ""
    switch (tipo) {
      case 'Arquivo1': arquivo = _Arquivo1; break;
    }
    let a = e.target.id;
    arquivo[a] = e.target.files[0];
    let nome = e.target.files[0].name;
    if (tipo === "Arquivo1") { setNomeArquivo1(nome); }
    if (!arquivo[a]) { return; } else if (!ListaTiposAnexos.includes(arquivo[a].type)) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: 'Arquivo selecionado não é permitido!',
      });
      if (tipo === "Arquivo1") { setFileArquivo1([]); setNomeArquivo1("Selecione"); setFotoArquivo1([]); document.getElementById("Arquivo1").value = ""; }
      return;
    } else {
      const reader = new FileReader();
      reader.onload = (e) => {
        var dataURL = reader.result;
        var imgBase64 = dataURL.split(",");
        if (tipo === "Arquivo1") { FileArquivo1[a] = imgBase64[1]; setFileArquivo1(FileArquivo1[a]); setArquivo1(imgBase64); }
      };
      reader.readAsDataURL(arquivo[a]);
      if (tipo === "Arquivo1") { setFotoArquivo1(arquivo[a]); }
    }
  };

  const CampoAnexo = (id, label, value, state) => {
    return (
      <>
        <InputContainer className="uk-width-1-1@m">
          <FormLabel className="uk-form-label">{label}</FormLabel>
          <div uk-form-custom="target: true" style={{width: '100%'}}>
              <input type="file" aria-label="Custom controls" placeholder={value} id={id} onChange={(e) => LeArquivo(e, id)} accept=".xls,.xlsx,.csv"/>
              <input className="uk-input input" type="text" placeholder={value} aria-label="Custom controls" disabled />
          </div>
        </InputContainer>
      </>
    )
  }

  return (
    <Cont>    

      <Container size="expand" className="content-padder content-padder-inative" id="padder" >            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge">  

              <Grid className="uk-flex uk-flex-middle uk-margin-medium">                
                <Section className="uk-width-expand">
                  <Section className="uk-inline">
                    <a className="uk-link-heading uk-flex uk-flex-middle">
                        <h4 className="uk-link-toggle uk-text-bold uk-margin-remove">
                          Profissionais
                        </h4>
                    </a>
                  </Section>
                </Section>
              </Grid>  
                    
              <Card className="uk-margin-medium-bottom">
                <CardBody>
                  <Grid className="uk-grid-small">                 
                
                    <Section className="uk-width-1-6@m">
                      <FormLabel className="uk-form-label">Nome</FormLabel>
                      <InputContainer>
                        <input
                          className="uk-input input"
                          type="text"
                          value={NomeFiltro}
                          onChange={e => setNomeFiltro(e.target.value)}
                        />
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">CPF</FormLabel>
                        <InputMask mask="999.999.999-99" maskChar=" " value={CPFFiltro} onChange={(e) => setCPFFiltro(e.target.value)}>
                          {() => (<input type="text" className="uk-input input" placeholder='' />)}
                        </InputMask>                                              
                      </InputContainer>
                    </Section>     

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (De)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadInicio}                    
                            onChange={e => setDataCadInicio(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Data de cadastro (Até)</FormLabel>
                        <input                                   
                            className="uk-input input"
                            type="date"
                            value={DataCadTermino}                    
                            onChange={e => setDataCadTermino(e.target.value)}
                          />                                               
                      </InputContainer>
                    </Section> 

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Status</FormLabel>  
                          <Select
                            defaultValue={StatusFiltro}
                            onChange={setStatusFiltro}
                            options={ListaStatus}
                            placeholder={"..."}
                            isLoading={!ListaStatus.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"
                          />  
                      </InputContainer>
                    </Section>

                    <Section className="uk-width-1-6@m">
                      <InputContainer>
                        <FormLabel className="uk-form-label">Habilitação</FormLabel>  
                          <Select
                            defaultValue={HabilitacaoFiltro}
                            onChange={setHabilitacaoFiltro}
                            options={_ListaHabilitacao}
                            placeholder={"..."}
                            isLoading={!_ListaHabilitacao.length}
                            className="basic-multi-select" 
                            classNamePrefix="uk-select"
                          />  
                      </InputContainer>
                    </Section>

                  </Grid>                              
                </CardBody>
              
                <CardFooter>
                  <Grid className="uk-grid-small uk-flex uk-flex-right">
                    <Section>
                      <button
                        type="button"                                            
                        id="Filtrar" 
                        className="uk-button uk-button-primary uk-float-right"                          
                        onClick={() => {GetListaProfissionaiss("Filtrar", "aguardeFiltro"); SetCurrentPage(1)}}        
                        value="Filtrar"   
                        //disabled={blockFiltro}                   
                      > 
                      <span  uk-icon="icon: search"></span> 
                        Filtrar                                        
                      </button>  

                      <button className="uk-button uk-button-primary" id="aguardeFiltro" style={{display:'none'}}>
                        <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                      </button>  

                    </Section>
                  </Grid>                                                           
                </CardFooter> 
              </Card>                
            
              { AlertMsg === true && <Alert color={color} content={msg}  duration={time} onHide={() => SetAlertMsg(false)} isClosable /> } 

              <Card className="uk-card-default uk-margin">

                <CardHeader>
                  <Grid className="uk-flex uk-flex-middle">
                    <Section className="uk-width-expand">
                      <h4 className="uk-card-title">Lista de Profissionais</h4>
                    </Section>
        
                    <Section className="uk-width-auto">
                      <Grid className="uk-flex uk-flex-right">
                        <Section>
                          <button className="uk-button uk-button-link" type="button" onClick={() => AbreModalCadastroProfissional()}>
                            <span uk-icon="icon: plus-box"></span> Novo Profissional
                          </button>
                        </Section>
                        {/* <Section>
                          <button className="uk-button uk-button-link" type="button" onClick={() => AbreModalCadastroProfissional()}>
                            <span uk-icon="icon: upload"></span> Importar Profissionais
                          </button>
                        </Section> */}
                        <Section>
                          {LoadingExportar ?
                          <button className="uk-button uk-button-link" type="button" disabled="disabled"><span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde</button>
                          :
                          <button className="uk-button uk-button-link" type="button" onClick={() => ExportarDados()}> <span uk-icon="icon: cloud-download"></span> Exportar </button>
                          }
                        </Section>
                      </Grid>
                    </Section>
                  </Grid>
                </CardHeader>

            { !ListaProfissionais ?
						<CardBody> <Loading /> </CardBody> 
            :
						<>
							<CardBody className="uk-child-width-expand@s uk-padding-small">
								<Section className="uk-margin-remove uk-padding-small uk-padding-remove-left uk-padding-remove-right">
									<div className="uk-overflow-auto">
										<table className="uk-table uk-table-divider uk-table-striped uk-table-small uk-text-small uk-table-middle  uk-table-hover">                                        
											<thead>
												<tr>  
													<th className="uk-text-left uk-table-shrink"></th>
													<th className="uk-text-left uk-table-shrink">Profissional</th>
                          <th className="uk-text-left uk-table-shrink">CPF</th>
													<th className="uk-text-left uk-table-expand">E-mail</th>
													<th className="uk-text-left uk-table-shrink">Telefone</th>
													<th className="uk-text-left uk-table-expand">UF - Cidade</th>
													<th className="uk-text-left uk-table-shrink">Status</th>
													<th className="uk-text-left uk-table-shrink">Habilitação</th>
													<th className="uk-text-center uk-table-shrink">Ação</th>
												</tr>
											</thead>                              
										<tbody>  
										{
											ListaProfissionais.length > 0 ?
												ListaProfissionais.map((item, index) => {

													return(
														<tr key={index}>
															<td className="uk-text-nowrap">
                                  <div className={'ImgProfissional'}>
                                    <img 
                                    key={index}
                                    src={`${item.urlImagemFoto}`} 
                                    onError={(e) => { e.target.src = ImgPerfilSemFoto }}
                                    width="40"
                                    alt={item.nome} 
                                  />
                                  </div>                                  
                              </td>                                  
															<td className="uk-text-nowrap">
                                <strong style={{textTransform: 'uppercase'}}>{item.nome}</strong> <br />
                                <small className="uk-text-muted"><strong>Especialização:</strong> {item.profissaoDescricao}</small>
                                <small className="uk-text-muted"><strong>Data de cadastro:</strong> {DateFormatTNew(item.dataCad)}</small>
                              </td>
															<td className="uk-text-nowrap">{MascaraCPNJCPF(item.documento)}</td>
															<td className="uk-text-nowrap" style={{textTransform: 'lowercase'}}>{item.email || '-'}</td>
															<td className="uk-text-nowrap">{item.celularDDD || ''} {item.celular || '-'}</td>
															<td className="uk-text-nowrap">{item.estado} - {item.cidade}</td>
															<td className="uk-text-nowrap">
                                <span className={`uk-label uk-text-capitalize ${item.statusId === 2476 ? 'uk-label-success' : item.statusId === 23013 ? 'uk-label-primary' : item.statusId === 6387 ? 'uk-label-danger' : ''}`}>
                                  {item.statusDescricao}
                                </span>
															</td>
															<td>
                                <span className={`uk-label uk-text-capitalize ${item.statusVagaId === 86481 ? 'uk-label-success' : item.statusVagaId === 86480 ? '' : item.statusVagaId === 37 ? 'uk-label-warning' : item.statusVagaId === 36 ? 'uk-label-danger' : ''}`}>
                                  {item.statusVagaDescricao}
                                </span>
                              </td>
															<td className="uk-text-nowrap">
                                {/* <button className="uk-icon-button" uk-icon="icon: pencil" uk-tooltip="title: Editar" onClick={() => AbreModalStatusProfissional(item)} /> */}
                                <div className="uk-inline">
                                    <button className="uk-icon-button" uk-icon="icon: dots-vertical"></button>
                                      <div uk-dropdown="mode: click; pos: bottom-right;" id={"dropdown"+item.entCod}>
                                        <ul className="uk-nav uk-dropdown-nav">                                               
                                            <li>
                                              <a onClick={() => { AbreModalStatusProfissional(item); UIkit.dropdown(document.getElementById("dropdown"+item.entCod)).hide(false);}}>
                                                <span uk-icon="icon: pencil"></span> Status de acesso
                                              </a>
                                            </li> 
                                            <li className="uk-nav-divider"></li>
                                            <li>
                                              <a onClick={() => { AbreModalStatusHabilitacao(item); UIkit.dropdown(document.getElementById("dropdown"+item.entCod)).hide(false); }}>
                                                <span uk-icon="icon: pencil"></span> Habilitação a vagas
                                              </a>
                                            </li>                                               
                                        </ul>
                                    </div>
                                </div>
                              </td>
														</tr>
													) 
												})
											:
												<tr className="uk-text-center">
													<td colSpan={10}>
													{mensagem}
													</td>
												</tr>
										}
										</tbody>
									</table>
									</div>
								</Section>
							</CardBody>                          
							{
								ListaProfissionais.length > 0 &&  
								<CardFooter>
									<Grid className="uk-grid-small uk-flex uk-flex-middle uk-flex-right">
									<>
										<Section className="uk-flex uk-flex-middle">                      
										<span className="uk-margin-small-right">Itens por Página:</span>
										<InputContainer className="uk-form-controls">
											<select className="uk-select" id="form-horizontal-select" onChange={(e) => {SetItensPerPage(e.target.value); SetCurrentPage(1)}}>
												<option value={25} selected={itensPerPage === "25" ? "selected" : ""}>25</option>
												<option value={50} selected={itensPerPage === "50" ? "selected" : ""}>50</option>
												<option value={75} selected={itensPerPage === "75" ? "selected" : ""}>75</option>   
												<option value={100} selected={itensPerPage === "100" ? "selected" : ""}>100</option>                                        
											</select>
										</InputContainer>
										</Section>

										<Section>
										<>										

										<ReactPaginate
												nextLabel=" >"                                  
												onClick={(e) => MudaPaginaItens(e)}                                         
												pageRangeDisplayed={3}
												marginPagesDisplayed={1}
												forcePage={currentPage - 1}
												pageCount={pageCount}
												hrefAllControls={true}
												previousLabel="< "
												pageClassName="page-item"
												pageLinkClassName="page-link"
												previousClassName="page-item"
												// previousLinkClassName="page-link"
												nextClassName="page-item"
												// nextLinkClassName="page-link"
												breakLabel="..."
												breakClassName="page-item"
												breakLinkClassName="page-link"
												containerClassName="uk-pagination"
												activeClassName="uk-active"
												renderOnZeroPageCount={null}
											/>
										</>
										</Section>
									</> 
									</Grid>                                   
								</CardFooter>
							}
						</>
            }
              </Card>
        
          </Section>
        </main>
      </Container>  

      <Modal isOpen={ModalAlteraStatus} centered id="sm">
        <ModalHeader>{'Alteração de Status'}</ModalHeader>

        <ModalBody>         
            <p className="uk-margin-bottom">Tem certeza que deseja alterar o status de acesso do profissional <strong>{DadosProfissional?.nome}</strong>?</p>  
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button type="button" className="uk-button uk-button-default" onClick={() => FechaModalStatusProfissional()}>
                <span uk-icon="icon: close"></span> Cancelar
              </button>
            </Section>
            <Section>
                <button type="button" id="deletar" className="uk-button uk-button-primary" onClick={() => AlterarStatusProfissional(DadosProfissional, "Acesso")}>
                  <span uk-icon="icon: check"></span> SIM! Alterar Status
                </button>      
                        
                <button className="uk-button uk-button-primary" id="aguardeDelet" style={{display:'none'}} disabled>
                  <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                </button>
              </Section>
          </Grid>
        </ModalFooter>
      </Modal>

      <Modal isOpen={ModalAlteraStatusHabilitacao} centered id="sm">
        <ModalHeader>{'Alteração de Status: ' + DadosProfissional?.nome}</ModalHeader>

        <ModalBody>         
          <Grid className="uk-grid-small">
              <Section className="uk-width-1-1@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">Habilitação a vagas</FormLabel>
                    <select className="uk-select" onChange={(e) => setStatusHabilitacao(e.target.value)}>
                      { ListaHabilitacao.length > 0 && ListaHabilitacao.map((item, index) => (
                        <option key={index} value={item.value} selected={StatusHabilitacao === item.value}>{item.label}</option>
                      )) }
                    </select>
                </InputContainer>
              </Section>
          </Grid>
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button type="button" className="uk-button uk-button-default" onClick={() => FechaModalStatusHabilitacao()}>
                <span uk-icon="icon: close"></span> Cancelar
              </button>
            </Section>
            <Section>
                <button type="button" id="deletar" className="uk-button uk-button-primary" onClick={() => AlterarStatusProfissional(DadosProfissional, "Habilitacao")}>
                  <span uk-icon="icon: check"></span> Alterar Status
                </button>      
                        
                <button className="uk-button uk-button-primary" id="aguardeDelet" style={{display:'none'}} disabled>
                  <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
                </button>
              </Section>
          </Grid>
        </ModalFooter>
      </Modal>

      <Modal isOpen={ModalCadastroProfissional} id="lg" centered>
        <ModalHeader>Cadastro de Profissional</ModalHeader>

        <ModalBody>
            <Section className="uk-width-1-1@m">
                <FormLabel className="uk-form-label">Tipo de cadastro <span className="uk-text-danger">*</span></FormLabel>
              <InputContainer>
                <label for={'unico'} className="uk-margin-small-right">
                  <input
                    type={'radio'}
                    className={'uk-radio'}
                    id={'unico'}
                    value={'unico'}
                    checked={TipoCadastro === 'unico' ? true : false}
                    onChange={e => setTipoCadastro(e.target.value)}
                  /> Cadastro único
                </label>
                
                <label for={'massa'} className="uk-margin-small-right">
                  <input
                    type={'radio'}
                    className={'uk-radio'}
                    id={'massa'}
                    value={'massa'}
                    checked={TipoCadastro === 'massa' ? true : false}
                    onChange={e => setTipoCadastro(e.target.value)}
                  /> Cadastro via arquivo
                </label>
              </InputContainer>
            </Section>
      
        {TipoCadastro === 'unico' ?
        <>
          <Grid className="uk-grid-small">

            <Section className="uk-width-1-1@m">
              <InputContainer>
                <FormLabel className="uk-form-label">CPF <span className="uk-text-danger">*</span></FormLabel>
                <InputMask 
                  mask="999.999.999-99"
                  maskChar=" " 
                  value={DadosCadastro?.cpf || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, cpf: e.target.value })} >                 
                  {() => (<input type="text" className="uk-input input" placeholder='Informe o CPF' />)}
                </InputMask>
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Nome completo <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o nome completo do profissional'
                  type="text"
                  value={DadosCadastro?.nome || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, nome: e.target.value })} />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">E-mail <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Informe o E-mail'
                  type="text"
                  value={DadosCadastro?.email || ''}
                  onChange={e => setDadosCadastro({ ...DadosCadastro, email: e.target.value })}
                />
              </InputContainer>
            </Section>

            <Section className="uk-width-1-2@m">
              <InputContainer>
                <FormLabel className="uk-form-label">Telefone <span className="uk-text-danger">*</span></FormLabel>
                <InputMask mask="(99) 999999999" maskChar=" " value={DadosCadastro?.telefone || ''} onChange={e => setDadosCadastro({ ...DadosCadastro, telefone: e.target.value })} >
                  {() => (<input type="text" className="uk-input input" placeholder='Informe o Telefone' />)}
                </InputMask>
              </InputContainer>
            </Section>


              <Section className="uk-width-1-2@m">
                <InputContainer>
                  <FormLabel className="uk-form-label">Especialização <span className="uk-text-danger">*</span></FormLabel>
                    <select className="uk-select" onChange={(e) => setDadosCadastro({ ...DadosCadastro, especializacao: e.target.value })}>
                      <option value="">Escolha uma especialização</option>
                      { ListaEspecializacao.length > 0 && ListaEspecializacao.map((item, index) => (
                        <option key={index} value={item.value} selected={DadosCadastro?.especializacao === item.value}>{item.label}</option>
                      )) }
                    </select>
                </InputContainer>
              </Section>
                
          </Grid>
        </>
        :
        <>
          <Grid className="uk-grid-small">

            <Section className="uk-width-1-1@m">
              {CampoAnexo('Arquivo1', 'Selecione o Arquivo', NomeArquivo1, Arquivo1)}
            </Section>

            <Section className="uk-width-1-1@m">
              <button type="button" title="Arquivo Modelo" className="uk-button uk-button-default" onClick={() => window.open(ArquivoModelo, '_blank')}> <span uk-icon="icon: download"></span> Arquivo Modelo</button>
            </Section>
                
          </Grid>
        </>
        }

        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button
                type="button"
                id='btn-fechar-cadastro'
                className="uk-button uk-button-danger"
                onClick={() => { FechaModalCadastroProfissional() }}
              >
                <span uk-icon="icon: close"></span> Fechar
              </button>
            </Section>
            <Section>
              {TipoCadastro === 'unico' ?
              <button
                type="button"
                id="btn-envia-formulario"
                className="uk-button uk-button-primary"
                onClick={() => CadastrarProfissional()}
              >
                <span uk-icon="icon: check"></span> Cadastrar
              </button>
              :
              <button
                type="button"
                id="btn-envia-formulario"
                className="uk-button uk-button-primary"
                onClick={() => UploadProfissionais()}
              >
                <span uk-icon="icon: upload"></span> Importar Profissionais
              </button>
              }

              <button className="uk-button uk-button-primary" id="btn-envia-formulario-loading" >
                <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
              </button>
            </Section>
          </Grid>
        </ModalFooter>
      </Modal>

    </Cont>
  );
}

export default Profissionais;
